import { once } from 'lodash';
import { retry } from '@wix/pricing-plans-utils/http';
import { type ControllerParams, IHttpClient } from '@wix/yoshi-flow-editor';
import { EcomServerless } from '../services/ecom-serverless';
import { getInstallationState } from './isMultiPageApp';

type ErrorHandler = ControllerParams['flowAPI']['errorHandler'];
type WixCodeApi = ControllerParams['flowAPI']['controllerConfig']['wixCodeApi'];
type AppParams = ControllerParams['flowAPI']['controllerConfig']['appParams'];

export const ECOM_APP_DEF_ID = '1380b703-ce81-ff05-f115-39571d94dfcd';

export enum BiCheckoutVersion {
  PricingPlans = 'Pricing Plans',
  Ecom = 'ecom',
}

export const isViewerOnEcom = once(
  async (
    httpClient: IHttpClient,
    wixCodeApi: WixCodeApi,
    appParams: AppParams,
    errorHandler: ErrorHandler,
  ): Promise<boolean> => {
    const ecom = new EcomServerless(httpClient, errorHandler);
    const { hasRouter, isMpaPagesInstalled, isMpaEcomPagesInstalled } = await getInstallationState(
      wixCodeApi,
      appParams,
    );
    if (hasRouter) {
      if (isMpaEcomPagesInstalled && !isMpaPagesInstalled) {
        return true;
      }
      return retry({ times: 2, delay: 500, backoff: 1 }, () => ecom.isInPopulation()).catch(() => false);
    }
    return false;
  },
);
